import {
    SET_SELECTED_GAME,
    SET_SELECTED_LEVEL
} from "./action_types"

export const setSelectedLevel = (levelNumber) => {
    return {
        type: SET_SELECTED_LEVEL,
        levelNumber
    };
};
export const setSelectedGame = (gameNumber) => {
    return {
        type: SET_SELECTED_GAME,
        gameNumber
    };
};